import { i18n } from "shared";

export const CityData = ({ queryKey }) => {
  const name = queryKey[1];
  const data = [
    {
      id: 1,
      url: i18n.language?.startsWith("en") ? "/osaka_en.pdf" : "/osaka_ja.pdf",
      cityName: "Osaka",
      inPoint: true,
      ellipsis: {
        university: true,
        economy: false,
      },
      population: i18n.language?.startsWith("en") ? "8.8 million" : "880万人",
      economy: i18n.language?.startsWith("en")
        ? `
        Osaka Prefecture’s the total production reaches
        over 360 billion USD,which surpasses Hong Kong and Singapore in terms of economic scale.
      `
        : `府内総生産は、名目41兆1884億円。香港やシンガポールを上回る。`,
      university: i18n.language?.startsWith("ja")
        ? `大阪大学、大阪公立大学、\n関西大学、近畿大学、大阪工業大学等\n56の大学が集積。多数の大学発 \nスタートアップを輩出。`
        : `There are 56 universities.
        ${`;`}Some of them have produced a lot of tech startups.
        ${`;`}Osaka University, Osaka Metropolitan University,
        ${`;`}Osaka Institute of Technology, Kindai University,
        ${`;`}Kansai University, etc.
        `,
      support: i18n.language?.startsWith("ja")
        ? `大阪イノベーションハブ（大阪スタートアップ・エコシステム コンソーシアム事務局 )`
        : "Osaka Innovation Hub (OIH) \n(Startup Ecosystem, International Division,\nOsaka Business Development Agency)",
      // supportEmail: i18n.language?.startsWith("ja")
      //   ? "s-upeco-info@obda.or.jp"
      //   : "s-upeco-info@obda.or.jp",
      access: i18n.language?.startsWith("ja")
        ? `関西国際空港\nJR大阪駅まで電車で約65分／バスで約60分`
        : "Kansai International Airport\n65 minutes by JR Line super-express HARUKA (directly link to shin-Osaka Station).\n60 minutes by Limousin bus (directly link to shin-Osaka Station).",
    },
    {
      id: 4,
      cityName: "Kyoto",
      inPoint: true,
      ellipsis: {},
      url: i18n.language?.startsWith("en") ? "/kyoto_en.pdf" : "/kyoto_ja.pdf",
      population: i18n.language?.startsWith("en")
        ? "2.57 million"
        : "２５７万人",
      economy: i18n.language?.startsWith("ja")
        ? `ＧＤＰ（名目）約１０兆円・主な企業 \n京セラ株式会社、株式会社島津製作所、\n株式会社 SCREEN ホールディングスなど
        `
        : `Nominal GDP about 90 billion USD.Major \ncompanies are KYOCERA Corporation,\nSHIMADZU Corporation,SCREEN Holdings Co.,Ltd,etc.`,
      university: i18n.language?.startsWith("ja")
        ? `京都大学、京都工芸繊維大学を始め、34大学が立地
        `
        : `34 universities. For example, Kyoto University,\nKyoto Institute of Technology, etc.`,
      support: i18n.language?.startsWith("ja")
        ? `京都スタートアップ・エコシステム 推進協議会（事務局：京都府、京都市、（一社）京都知恵産業創造の森）`
        : "Kyoto Startup Ecosystem Promotion Council \n(Kyoto Prefecture,Kyoto City, \nKyoto wisdom industry creation center）",
      access: i18n.language?.startsWith("ja")
        ? `関西国際空港 \nJR線特急「はるか」で1.5時間（京都駅まで直通） \nリムジンバスで1.5 時間（京都駅まで直通）`
        : "Kansai International Airport \n1.5 hours by JR Line super-express HARUKA\n(directly link to Kyoto station).1.5 hours\nby Limousine bus (directly link to Kyoto station).",
    },
    {
      id: 2,
      cityName: "Sakai",
      inPoint: true,
      ellipsis: {},
      population: i18n.language?.startsWith("ja") ? "81万人" : "0.81 million",
      economy: i18n.language?.startsWith("ja")
        ? `３兆４８０７億円
        ${`;`}（令和2年度 名目市内総生産）`
        : "Nominal GDP about 3,480.7 billion yen.",
      university: i18n.language?.startsWith("ja")
        ? `大阪公立大学、関西大学、帝塚山学院大学、羽衣国際大学など`
        : `Osaka Metropolitan University, Kansai University,\nTezukayama Gakuin University,\nHAGOROMO University of International Studies, etc.`,
      support: i18n.language?.startsWith("ja")
        ? "堺市 産業振興局 産業戦略部 中百舌鳥イノベーション創出拠点担当 \nTEL：072-228-7629\n"
        : "Nakamozu Innovation Center,\nIndustrial Strategy Department,\nIndustrial Promotion Bureau\n, \nSakai City\nTEL：072-228-8816\n",
      supportEmail: "itosoku@city.sakai.lg.jp",
      access: i18n.language?.startsWith("ja")
        ? "関西空港駅から堺駅 約３０分（電車）"
        : "About 30 min by train from Kansai International Airport",
    },
    {
      id: 5,
      cityName: "Shiga",
      ellipsis: {
        university: i18n.language?.startsWith("ja") ? false : true,
      },
      population: i18n.language?.startsWith("ja")
        ? "１４１万人"
        : "1.41 million",
      economy: i18n.language?.startsWith("ja")
        ? `県内総生産（名目）6兆8,637億円 \n県内総生産に占める製造業の割合は44% で全国１位。多くの企業のマザー工場や研究開発拠点が集積。`
        : `Nominal GDP about 6,863.7 billion yen.\nThe manufacturing industry accounts for 44% of the prefecture's gross domestic product, ranking first in the country. Mother factories and R&D bases of many companies are concentrated.`,
      university: i18n.language?.startsWith("ja")
        ? `様々な専門分野を持つ14 の大学が集積。人口10万人あたりの学生数は全国第６位。`
        : "A collection of 14 universities with various specialties.\nThe number of students per 100,000 population \nis the 6th largest in Japan.",
      support: i18n.language?.startsWith("ja")
        ? `滋賀県 商工観光労働部 イノベーション推進課\n`
        : "Shiga Prefectural Government Ministry of Commerce, Industry,\nTourism and Labor \nInnovation Promotion Division \n",
      supportEmail: "fd00@pref.shiga.lg.jp",
      access: i18n.language?.startsWith("ja")
        ? `関西国際空港\nJR特急はるか（大津駅直結）で1.5時間。`
        : "Kansai International Airport\n1.5 hours by JR Line super-express HARUKA (directly link to Otsu station).",
    },
    {
      id: 7,
      inPoint: true,
      cityName: "Tokushima",
      population: i18n.language?.startsWith("ja") ? "６８万人" : "0.68 million",
      economy: i18n.language?.startsWith("ja")
        ? `３兆１，７３３億円`
        : `Nominal GDP of over 23 billion USD`,
      university: i18n.language?.startsWith("ja")
        ? `徳島大学
            ${`;`}徳島文理大学
            ${`;`}四国大学
          `
        : `Tokushima University
        ;Tokushima Bunri University
        ;Shikoku University`,
      support: i18n.language?.startsWith("ja")
        ? "徳島県経済産業部産業創生・大学連携課"
        : `Industrial Creation and University Collaboration Division, Department of Economy, Trade and Industry, Tokushima Prefecture `,
      // supportEmail: "shinmiraisangyouka@pref.tokushima.jp",
      access: i18n.language?.startsWith("ja")
        ? `飛行機 :【東京～徳島】1 時間 10 分
       \n高速バス :【関西空港～徳島】2 時間 45 分`
        : `By Air\n【Tokyo⇔Tokushima】1 hour 10 min \nBy Highway Bus\n【Osaka⇔Tokushima】2 hours 30 min \n Kansai International Airport⇔Tokushima】2 hours 45 min`,
    },
    {
      id: 8,
      cityName: "Tottori",
      inPoint: false,
      ellipsis: {},
      population: i18n.language?.startsWith("ja") ? "５３万人" : "0.53million",
      economy: i18n.language?.startsWith("ja")
        ? `１兆８，１９９億円（名目県内総生産：令和２年度））`
        : "1,819.9 billion yen (nominal gross prefectural product: FY 2020)",
      university: i18n.language?.startsWith("ja")
        ? `鳥取大学、公立鳥取環境大学`
        : "Tottori University,\nTottori University of Environmental Studies",
      support: i18n.language?.startsWith("ja")
        ? `鳥取県商工労働部産業未来創造課 \n〒680-8570 鳥取県鳥取市東町1丁目 220 \n電話: 0857-26-7246`
        : `Tottori Prefecture, Industry and Labor Department, \nIndustrial Future Creation Division \n1-220 Higashimachi, Tottori City, \nTottori Prefecture 680-8570 \nPhone: 0857-26-7690 `,
      supportEmail: "sangyoumirai@pref.tottori.lg.jp",
      access: i18n.language?.startsWith("ja")
        ? `大阪から 鳥取 特急スーパーはくと 約2時間20分 \n米子 ( 新大阪 ) 新幹線ー( 岡山乗換 )ー \n特急スーパーやくも 約 3 時間 10 分`
        : "2 hours 20 min by JR Line limited express \nSuper HAKUTO from Osaka",
    },

    {
      id: 6,
      cityName: "Wakayama",
      inPoint: true,
      population: i18n.language?.startsWith("ja") ? "８９万人" : "0.89 million",
      economy: i18n.language?.startsWith("ja")
        ? `３６,２２２億円`
        : `Nominal GDP about 36,222 billion yen.`,
      university: i18n.language?.startsWith("ja")
        ? `和歌山大学
        ${`;`}和歌山県立医科大学
      `
        : `Wakayama University${`;`}Wakayama Medical University`,
      support: i18n.language?.startsWith("ja")
        ? "和歌山県商工労働部企業政策局成長産業推進課"
        : "Growth Industry Promotion Division, Corporate Policy Bureau, Commerce, Industry and Labor Department, Wakayama Prefecture",
      supportEmail: "e0631001@pref.wakayama.lg.jp",
      access: i18n.language?.startsWith("ja")
        ? "新大阪駅から電車で1時間、関西国際空港から電車で50分"
        : "1 hour from Shin-Osaka Station by train, 50 minutes from Kansai International Airport by train",
    },
    {
      id: 3,
      cityName: "hyogo_kobe",
      inPoint: true,
      url: i18n.language?.startsWith("en") ? "" : "/hyogo_kobe_ja.pdf",

      population: i18n.language?.startsWith("ja") ? "535万人" : "5.35 million",
      economy: i18n.language?.startsWith("ja")
        ? `兵庫県内の経済規模（県内GDP）は約23兆円`
        : "23 trillion yen.",
      university: i18n.language?.startsWith("ja")
        ? `神戸大学、関西学院大学をはじめ、35大学が立地`
        : "35 universities including Kobe University \n Kwansei Gakuin University are located in the area.\n",
      support: i18n.language?.startsWith("ja")
        ? `ひょうご神戸スタートアップ・エコシステムコンソーシアム事務局\n`
        : "Hyogo Kobe Startup Ecosystem Consortium Secretariat\n",
      supportEmail: "shinsangyosozo@office.city.kobe.lg.jp",
      access: i18n.language?.startsWith("ja")
        ? `空路：東京（羽田）から神戸空港まで約65分\n新幹線：東京から新神戸まで2時間41分 \n`
        : "By Air: Tokyo(Haneda) ⇔ Kobe about 1 hour,\nBy Shinkansen: Tokyo ⇔ Shin-kobe about 2 hours half",
      accessURL: "https://kobe-investment.jp/charm/access/",
    },
    {
      id: 9,
      cityName: "nara",
      inPoint: true,
      url: "",
      population: i18n.language?.startsWith("ja") ? "131万人" : "1.31 million",
      economy: i18n.language?.startsWith("ja")
        ? `約４兆円（名目県内総生産）`
        : "Approx. 4 trillion yen (nominal gross prefectural product)",
      university: i18n.language?.startsWith("ja")
        ? `奈良県立大学、奈良県立医科大学、国立奈良女子大学、国立奈良先端科学技術大学院大学、近畿大学農学部 など`
        : "Nara Prefectural University, Nara Medical University, Nara Women's National University, Nara Institute of Science and Technology, Faculty of Agriculture, Kinki University, etc.",
      support: i18n.language?.startsWith("ja")
        ? `奈良県 地域創造部\n大和平野中央構想・スタートアップ推進課\n`
        : "Regional Development Department, Nara Pref.\nYamato Plain Central Concept and Start-up Promotion Division",
      supportEmail: "",
      access: i18n.language?.startsWith("ja")
        ? `関西国際空港から奈良市内まで、電車で約90分\n`
        : "Approximately 90 minutes from Kansai International Airport to Nara City by train.",
      // accessURL: "https://www.pref.nara.jp/65307.htm",
    },
  ];
  const filteredData = data.find(
    (item) => item.cityName?.toLowerCase() == name
  );
  return filteredData;
};
